import React from "react";
import { useParams } from "react-router-dom";
import InvoiceLabelView from "../views/admin/InvoiceLabelView";

const InvoiceLabel: React.FC = () => {
    const { ids } = useParams();

    return <div className="ph-10">
        <InvoiceLabelView ids={ids ?? ""} />
    </div>;
};

export default InvoiceLabel;